import React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import { isLoggedIn, isPremium } from "../../services/auth";
import { selectContent } from "../../services/basket";
import { parameterize } from "../../utils/string";

const CardLoginButton = ({ slug, title, vid }) => {
  const link = `/subscription`

  if (!isLoggedIn()) {
    return (
      <div
        key={`cta-login-${vid}`}
        className="flex flex-row w-full">
        <Link
          to={link}
          state={{ login: true, title }}
          onClick={() => selectContent({ contentType: `cta-login`, itemId: parameterize(title) })}
          onKeyDown={() => selectContent({ contentType: `cta-login`, itemId: parameterize(title) })}
          className="joinNow text-center w-full py-2 font-medium text-white text-base md:text-lg bg-gradient-to-r from-green-800 to-green-900 hover:from-green-900 hover:to-black transition-all duration-300 ease-in-out shadow-md"
        >
          Get the full version now!
        </Link>
      </div>
    )
  } else if (isLoggedIn() && !isPremium()) {
    return(
      <div
        key={`cta-subscribe-${vid}`}
        className="flex flex-row w-full">
        <Link
          to={link}
          className="text-white py-2 subscribeNow text-center w-full font-medium text-base md:text-lg bg-gradient-to-r from-blue-600 to-blue-800 hover:from-blue-700 hover:to-blue-900 transition-all duration-300 ease-in-out shadow-md"
          onClick={() => selectContent({ contentType: `cta-subscribe`, itemId: parameterize(title) })}
          onKeyDown={() => selectContent({ contentType: `cta-subscribe`, itemId: parameterize(title) })}
          state={{ pay: true, title }}>
          Get the full version now!
        </Link>
      </div>
    )
  } else {
    return(null)
  }
}

CardLoginButton.propTypes = {
  vid: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}

export default CardLoginButton
